/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { billing_ContractedServiceDTO } from './billing_ContractedServiceDTO';
import type { billing_DiscountRequest } from './billing_DiscountRequest';
import type { billing_PayerRequest } from './billing_PayerRequest';
import type { billing_ServicePatternRequest } from './billing_ServicePatternRequest';
import type { billing_TariffVersionAssignmentDTO } from './billing_TariffVersionAssignmentDTO';
import type { shared_FlexibleDate } from './shared_FlexibleDate';
export type billing_UpdateContractRequest = {
    /**
     * Beitragsfaktor — parent-contribution factor in [0,1] (0 means city covers 100% of the subsidisable portion). Stored as NUMERIC(5,4).
     */
    beitragsfaktor?: number;
    /**
     * Subsidy case record (issue #2001), per contract version and copied on a
     * version split. Not read by invoice generation.
     * BeitragsfaktorValidFrom — first day the BF of this version applies.
     */
    beitragsfaktor_valid_from?: shared_FlexibleDate;
    /**
     * BeitragsfaktorValidUntil — date the BF expires.
     */
    beitragsfaktor_valid_until?: shared_FlexibleDate;
    /**
     * Enhanced billing fields
     */
    billing_end_date?: shared_FlexibleDate;
    /**
     * Enhanced billing fields
     */
    billing_start_date?: shared_FlexibleDate;
    /**
     * ClearSubsidyAmountOverride removes the override entirely (back to the normal
     * engine). Needed because a null amount means "leave unchanged" — 0 already
     * means "bill the office nothing". Takes precedence over the amount.
     */
    clear_subsidy_amount_override?: boolean;
    /**
     * ClearSubsidyCaseFields — case fields to set to NULL (a date cannot carry
     * "remove"). Applied after the values above and wins over them.
     */
    clear_subsidy_case_fields?: Array<string>;
    /**
     * ContractedServices directly from frontend with group types
     */
    contracted_services?: Array<billing_ContractedServiceDTO>;
    /**
     * Discounts to update
     */
    discounts?: Array<billing_DiscountRequest>;
    /**
     * EndDate to change
     */
    end_date?: shared_FlexibleDate;
    /**
     * KmbB supplement (#2007): nil leaves it unchanged; false also removes
     * KmbbValidUntil, which the clear list removes on its own.
     */
    kmbb?: boolean;
    kmbb_valid_until?: shared_FlexibleDate;
    /**
     * Notes to update
     */
    notes?: string;
    /**
     * Payers to update (must sum to 100 if provided)
     */
    payers?: Array<billing_PayerRequest>;
    /**
     * SBUValidUntil — last day the SBU (Subventionsberechtigter Betreuungsumfang) confirmation is valid.
     */
    sbu_valid_until?: shared_FlexibleDate;
    /**
     * ServicePattern to update
     */
    service_pattern?: billing_ServicePatternRequest;
    /**
     * SiblingDiscountManual flag to update — disables auto sibling discount for the whole household when true.
     */
    sibling_discount_manual?: boolean;
    /**
     * StartDate to change
     */
    start_date?: shared_FlexibleDate;
    /**
     * Status is deprecated for updates — status changes happen via dedicated endpoints
     * (TerminateContract, CancelContractVersion). Retained for backward compatibility but ignored.
     */
    status?: billing_UpdateContractRequest.status;
    /**
     * Subsidised flag to update
     */
    subsidised?: boolean;
    /**
     * SubsidyAmount is the flat BASE subvention amount in Rappen (>= 0 and <= 1000000,
     * i.e., max 10000 CHF). When > 0 it requires SubsidyOfficeID. See CreateContractRequest
     * for the method-dependent semantics (parent-reducing under a flat office; must be 0 under zurich_bf).
     */
    subsidy_amount?: number;
    /**
     * SubsidyAmountOverrideRappen is an EXACT office share in Rappen for this
     * contract version, taken at face value: never pro-rated, never re-rounded.
     * When set it overrides both base engines (the zurich_bf Beitragsfaktor
     * engine and the flat SubsidyAmount): the office is billed exactly this and
     * the parent pays Tarif − override. Omitted/null = no override; 0 is
     * meaningful ("bill the office nothing"). Requires SubsidyOfficeID.
     */
    subsidy_amount_override_rappen?: number;
    /**
     * SubsidyApplicationFiledOn — day the Finanzierungsantrag was filed; no subsidy applies before it.
     */
    subsidy_application_filed_on?: shared_FlexibleDate;
    /**
     * SubsidyDecisionNumber — the office's decision number (EBB). Trimmed; blank means none.
     */
    subsidy_decision_number?: string;
    /**
     * SubsidyDecisionOn — day the office decided; never before the filing day.
     */
    subsidy_decision_on?: shared_FlexibleDate;
    /**
     * SubsidyDecisionPending — hold flag (see CreateContractRequest). When true the
     * subsidy fields are optional and invoice generation is held until cleared.
     */
    subsidy_decision_pending?: boolean;
    /**
     * SubsidyOfficeID — FK to subsidy_offices (slice 1).
     */
    subsidy_office_id?: string;
    /**
     * SubsidySupplementAmount — flat on-top Subventionszuschuss in Rappen, billed to the
     * office and never reducing the parent. Requires SubsidyOfficeID when > 0.
     */
    subsidy_supplement_amount?: number;
    /**
     * TariffVersions to change
     */
    tariff_versions?: Array<billing_TariffVersionAssignmentDTO>;
};
export namespace billing_UpdateContractRequest {
    /**
     * Status is deprecated for updates — status changes happen via dedicated endpoints
     * (TerminateContract, CancelContractVersion). Retained for backward compatibility but ignored.
     */
    export enum status {
        ACTIVE = 'active',
        CANCELLED = 'cancelled',
        TERMINATED = 'terminated',
    }
}

